module.exports = __webpack_public_path__ + "static/img/gacc.2d5c5e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/gacc.jpg
// module id = k+Px
// module chunks = 1